import { ISettlementAndFeeCategoryDefinitionData } from 'types/order/fees/ISettlementAndFeeCategoryDefinition';
import { ICreateSettlementFeeForm } from '../../../../../types/order/fees/ICreateSettlementItemForm';

export const availablePropertiesBySelection = (
  options: ISettlementAndFeeCategoryDefinitionData[],
  selectedId?: string,
  fee?: ICreateSettlementFeeForm,
  readOnly?: boolean
) => {
  const selectedOption = options.find((t) => t.statementSettlementAndFeeCategoryDefinitionId === selectedId);
  if (!selectedOption) {
    if (readOnly && fee) {
      return {
        ...Object.keys(fee.stringFeePropertyValues).reduce((p, c) => ({ ...p, [c]: true }), {}),
        ...Object.keys(fee.numericFeePropertyValues).reduce((p, c) => ({ ...p, [c]: true }), {}),
        canAddMoreFees: false,
      };
    }
    return {
      canAddMoreFees: false,
    };
  }
  return {
    ...selectedOption.stringFeePropertyNames.reduce((p, c) => ({ ...p, [c]: true }), {}),
    ...selectedOption.numericFeePropertyNames.reduce((p, c) => ({ ...p, [c]: true }), {}),
    canAddMoreFees: selectedOption.allowGrouping,
  };
};
